import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'ramda';
import ReactMapGL, { Marker } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import { Container, MapWrapper, MarkerIcon } from './map.styles';

export class MapComponent extends PureComponent {
  static propTypes = {
    markerLatitude: PropTypes.number,
    markerLongitude: PropTypes.number,
  };

  static defaultProps = {
    markerLongitude: 0,
    markerLatitude: 0,
  };

  state = {
    viewport: {
      latitude: this.props.markerLatitude,
      longitude: this.props.markerLongitude,
      zoom: 12,
    },
  };

  handleViewportChange = viewport => this.setState({ viewport });

  render() {
    return (
      <Container>
        <MapWrapper>
          <ReactMapGL
            mapStyle={process.env.REACT_APP_MAPBOX_STYLE_URL}
            mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_API_KEY}
            {...this.state.viewport}
            onViewportChange={this.handleViewportChange}
            scrollZoom={false}
          >
            <Marker latitude={this.props.markerLatitude} longitude={this.props.markerLongitude}>
              <MarkerIcon />
            </Marker>
          </ReactMapGL>
        </MapWrapper>
      </Container>
    );
  }
}

export const Map = compose(injectIntl)(MapComponent);
